import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasRole } from '../utils/helpers';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // Giriş yapmayan kullanıcılar için basit navbar
  if (!user) {
    return (
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo-link">
            <div className="navbar-brand">
              <img src="/dicle.png" alt="Dicle Üniversitesi" className="navbar-logo" />
              <div className="navbar-brand-text">
                <h2 className="navbar-title">Dicle Üniversitesi</h2>
                <span className="navbar-subtitle">Geribildirim Sistemi</span>
              </div>
            </div>
          </Link>


          <div className="navbar-menu">
            <Link to="/login" className="navbar-login-link">
              Personel Girişi
            </Link>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <img src="/dicle.png" alt="Dicle Üniversitesi" className="navbar-logo" />
          <div className="navbar-brand-text">
            <h2 className="navbar-title">Dicle Üniversitesi</h2>
            <span className="navbar-subtitle">Geribildirim Sistemi</span>
          </div>
        </div>

        <div className="navbar-menu">
          {(hasRole(user.roles, 'SuperAdmin') || hasRole(user.roles, 'Admin')) && (
            <Link to="/admin" className="navbar-button">
              Yönetim
            </Link>
          )}

          <div className="navbar-user">
            <button
              className="user-avatar"
              onClick={toggleDropdown}
            >
              {user.firstName[0]}{user.lastName[0]}
            </button>

            {showDropdown && (
              <div className="user-dropdown">
                <div className="user-info">
                  <div className="user-name">
                    {user.firstName} {user.lastName}
                  </div>
                  <div className="user-email">
                    {user.email}
                  </div>
                  {user.department && (
                    <div className="user-department">
                      {user.department}
                    </div>
                  )}
                </div>
                <div className="dropdown-divider"></div>
                <Link to="/dashboard" className="dropdown-item">
                  Dashboard
                </Link>
                <Link to="/feedback-list" className="dropdown-item">
                  Geri Bildirimler
                </Link>
                {(hasRole(user.roles, 'SuperAdmin') || hasRole(user.roles, 'Admin')) && (
                  <Link to="/admin" className="dropdown-item">
                    Yönetim Paneli
                  </Link>
                )}
                {hasRole(user.roles, 'SuperAdmin') && (
                  <>
                    <Link to="/qr-codes" className="dropdown-item">
                      QR Kodlar
                    </Link>
                    <Link to="/user-management" className="dropdown-item">
                      Kullanıcı Yönetimi
                    </Link>
                  </>
                )}
                <div className="dropdown-divider"></div>
                <button className="dropdown-item logout" onClick={handleLogout}>
                  Çıkış Yap
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;